import React, {Component} from 'react';
import {byPropKey} from "../utils";
import RecordingsTab from "./recordings/RecordingsTab";
import LiveGPSTab from "./livegps/LiveGPSTab";
import LiveViewTab from "./liveview/LiveViewTab";
import MediaQuery from "react-responsive";
import {
    BOOTSTRAP_MAX_SM, BOOTSTRAP_MIN_SM,
    BOOTSTRAP_MIN_XS
} from "../../constants/bootstrapResponsive";
import {SummaryTab} from "./summary/SummaryTab";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {compose} from "recompose";
import {parse} from "query-string";

export const TAB_SUMMARY = 'tsu';
export const TAB_RECORDINGS = 'trs';
export const TAB_LIVE_GPS = 'tlg';
export const TAB_LIVE_VIEW = 'tlv';

/**
 * A switcher component that encapsulates and
 * switches the tab view currently displayed
 * to the user on the dashboard.
 */
class UnitTabSwitcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTab: parse(this.props.location.search).tab
        };
    }

    setSummaryTabState = () => {
        this.setState(byPropKey('currentTab', TAB_SUMMARY));
    };

    setRecordingsTabState = () => {
        this.setState(byPropKey('currentTab', TAB_RECORDINGS));
    };

    setLiveGPSTabState = () => {
        this.setState(byPropKey('currentTab', TAB_LIVE_GPS));
    };

    setLiveViewTabState = () => {
        this.setState(byPropKey('currentTab', TAB_LIVE_VIEW));
    };

    getTabToShow = (currentTab) => {
        switch(currentTab) {
            case TAB_LIVE_GPS:
                return <LiveGPSTab selectedUnit={this.props.selectedUnit || null}/>;
            case TAB_LIVE_VIEW:
                return <LiveViewTab selectedUnit={this.props.selectedUnit || null}/>;
            case TAB_RECORDINGS:
                return <RecordingsTab selectedUnit={this.props.selectedUnit || null}/>;
            case TAB_SUMMARY:
                // fallthrough default case
            default:
                return <SummaryTab selectedUnit={this.props.selectedUnit || null}/>;
        }
    };

    render() {
        const tabToShow = this.getTabToShow(this.state.currentTab);
        const unselectedClass = "btn btn-outline-secondary btn-lg";
        const selectedClass = "btn btn-secondary btn-lg";

        return (
            <div>
                <div className="text-center">
                    <div
                        className="btn-group"
                        style={{
                            margin: '15px auto',
                            display: 'inline-block',
                            width: 'inherit',
                            textAlign: 'center'
                        }}
                        role="group"
                    >
                        <div
                            onClick={this.setSummaryTabState}
                            className={
                                this.state.currentTab !== TAB_RECORDINGS &&
                                this.state.currentTab !== TAB_LIVE_VIEW &&
                                this.state.currentTab !== TAB_LIVE_GPS ? selectedClass : unselectedClass
                            }
                        >
                            <i className="fas fa-tachometer-alt"/>
                            <MediaQuery minWidth={BOOTSTRAP_MIN_XS}>
                                <MediaQuery maxWidth={BOOTSTRAP_MAX_SM}>
                                    <span className="small">{' Summary'}</span>
                                </MediaQuery>
                                <MediaQuery minWidth={BOOTSTRAP_MIN_SM}>
                                    <span>{' Summary'}</span>
                                </MediaQuery>
                            </MediaQuery>
                        </div>
                        <div
                            onClick={this.setRecordingsTabState}
                            className={this.state.currentTab === TAB_RECORDINGS ? selectedClass : unselectedClass}
                        >
                            <i className="fas fa-file-video"/>
                            <MediaQuery minWidth={BOOTSTRAP_MIN_XS}>
                                <MediaQuery maxWidth={BOOTSTRAP_MAX_SM}>
                                    <span className="small">{' Recordings'}</span>
                                </MediaQuery>
                                <MediaQuery minWidth={BOOTSTRAP_MIN_SM}>
                                    <span>{' Recordings'}</span>
                                </MediaQuery>
                            </MediaQuery>
                        </div>
                        <div
                            onClick={this.setLiveGPSTabState}
                            className={this.state.currentTab === TAB_LIVE_GPS ? selectedClass : unselectedClass}
                        >
                            <i className="fas fa-map-marker-alt"/>
                            <MediaQuery minWidth={BOOTSTRAP_MIN_XS}>
                                <MediaQuery maxWidth={BOOTSTRAP_MAX_SM}>
                                    <span className="small">{' Live GPS'}</span>
                                </MediaQuery>
                                <MediaQuery minWidth={BOOTSTRAP_MIN_SM}>
                                    <span>{' Live GPS'}</span>
                                </MediaQuery>
                            </MediaQuery>
                        </div>
                        <div
                            onClick={this.setLiveViewTabState}
                            className={this.state.currentTab === TAB_LIVE_VIEW ? selectedClass : unselectedClass}
                        >
                            <i className="fas fa-eye"/>
                            <MediaQuery minWidth={BOOTSTRAP_MIN_XS}>
                                <MediaQuery maxWidth={BOOTSTRAP_MAX_SM}>
                                    <span className="small">{' Live View'}</span>
                                </MediaQuery>
                                <MediaQuery minWidth={BOOTSTRAP_MIN_SM}>
                                    <span>{' Live View'}</span>
                                </MediaQuery>
                            </MediaQuery>
                        </div>
                    </div>
                </div>

                {tabToShow}
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    selectedUnit: state.unitsState.selectedUnit
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(UnitTabSwitcher);



// WEBPACK FOOTER //
// ./src/components/unit/UnitTabSwitcher.jsx